export const SESSION_START_KEY = "redo.session-start";

export const MERCHANT_VERSION = "redo.merchant-version";

const MAX_TIME_WITHOUT_REFRESH = Temporal.Duration.from({ days: 7 }).total(
  "milliseconds",
);

export function sessionNeedsRefreshing({
  currentVersion,
}: {
  currentVersion: number | null;
}): boolean {
  try {
    return hasSessionExpired() || isVersionOutOfDate({ currentVersion });
  } catch (e) {
    console.error("Error checking for session refresh", e);
    return false;
  }
}

function hasSessionExpired(): boolean {
  const sessionStartString = localStorage.getItem(SESSION_START_KEY);
  if (!sessionStartString) {
    return false;
  } // No session start time means we just set it

  const sessionStart = Temporal.Instant.from(sessionStartString);
  const now = Temporal.Now.instant();
  const sessionAge = now.since(sessionStart).total("milliseconds");

  return sessionAge > MAX_TIME_WITHOUT_REFRESH;
}

function isVersionOutOfDate({
  currentVersion,
}: {
  currentVersion: number | null;
}): boolean {
  const storedVersionString = localStorage.getItem(MERCHANT_VERSION);
  if (!storedVersionString || currentVersion === null) {
    return false;
  }

  const storedVersion = Number(storedVersionString);
  if (isNaN(storedVersion)) {
    return false;
  }

  return storedVersion !== currentVersion;
}

export function setSessionVersionNumber(version: number): void {
  localStorage.setItem(MERCHANT_VERSION, version.toString());
}

export function removeSessionVersionNumber(): void {
  localStorage.removeItem(MERCHANT_VERSION);
}

export function setSessionStartKey(): void {
  const now = Temporal.Now.instant().toString();
  localStorage.setItem(SESSION_START_KEY, now);
}

export interface TeamRefreshVersion {
  teamId: string;
  version: number | null;
}

export function teamRefreshVersionChanged(
  loaded: TeamRefreshVersion | null,
  current: TeamRefreshVersion,
): boolean {
  return (
    loaded?.teamId === current.teamId &&
    current.version != null &&
    current.version !== loaded.version
  );
}
